import React, { useState } from 'react';
import className from 'classnames';
import axios from 'axios';
import moment from 'moment';
import Waypoint from 'react-waypoint';

import Loading from '../Loading';
import TableHeader from '../TableHeader';

const UserScores = ({
  userId,
  title,
  path
}) => {
  const [userScores, setUserScores] = useState([])
  const [shouldFetch, setShouldFetch] = useState(true)

  const _fetchData = () => {
    if (shouldFetch) {
      fetchUserScores()
    }
  }

  const fetchUserScores = () => {
    axios.get(path, {
      params: {
        user_ids: [userId],
        scope: 'all'
      }
    })
      .then((res) => {
        if (res.status == 200) {
          setShouldFetch(false)
          setUserScores(res.data)
        }
      })
  }

  const displayBreakdownValue = (breakdownValue) => {
    if (typeof breakdownValue === 'object') {
      return `${breakdownValue.score} (${breakdownValue.grade})`
    } else {
      return breakdownValue.toString()
    }
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h3 className='MainHeader__h3'>{title}</h3>
        </div>
      </div>
      <Waypoint onEnter={_fetchData}>
        <div
          className={className('Table', {
            'Table--trust-parameters': true,
          })} style={{gridTemplateColumns: '1fr 1fr 1.5fr 6fr'}}
        >
          {(() => {
          const columnHeaders = [
            {
              label: 'Grade',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Score',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Updated at',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Breakdown'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
            )
          })()}
          <Loading isLoading={shouldFetch}>
            {
              userScores.length < 1 &&
                <div className='Table__row__no-records'>No records</div>
            }
            {userScores.map((userScore) => (
              <div
                className='Table__row'
                key={userId}
              >
                <div className='Table__col Table__col--ta-c'>{userScore.grade}</div>
                <div className='Table__col Table__col--ta-r'>{(+userScore.score).toLocaleString()}</div>
                <div className='Table__col Table__col--ta-r'>{moment(userScore.updated_at).format('YYYY-MM-DD HH:mm:ss')}</div>
                <div className='Table__col'>
                  <table>
                    <tbody>
                      {
                        Object.entries(userScore.breakdown).map(([key, value]) => {
                          return(
                            <tr key={`${userScore.id}${key}`}>
                              <td>{key}</td>
                              <td className='TrustScoreTable__col--number'>{displayBreakdownValue(value)}</td>
                            </tr>
                          )
                        })
                      }
                  </tbody>
                  </table>
                </div>
              </div>
            ))}
          </Loading>
        </div>
      </Waypoint>
    </React.Fragment>
  )
}

export default UserScores
